/**
 * api地址管理
 */
export default {
    // 字典查询
    dictByType:'/system/dict/data/type/',

    auctioneer:'/auction/web/auctioneer/',// 获取拍卖师信息get
    user_apply:'/user/web/apply',// 标的报名  POST
    user_edit:'/user/web/edit',//修改用户信息  PUT
    user_getInfo:'/user/web/getInfo',//获得登录用户信息  GET
    user_updatePwd:'/user/web/updatePwd',//更新密码  GET
    login:'/webLogin',//登录  POST
    user_add:'/user/web/price/add',//新增出价记录  POuser_ST
    user_register:'/user/web/register',//用户注册  POST
    user_security:'/user/web/security',//实名认证 POST
    sendAuthCode:'/user/web/sendAuthCode',//发送短信
    checkAuthCode:'/user/web/checkAuthCode',//验证短信验证码
    user_list:'/user/web/target/list',//查询我的标的管理列表 GET
    // 拍卖师操作
    target_finish:'/user/web/target/finish', //拍卖师结束标的 2 已流拍 3 已成交
    target_restart:'/user/web/target/restart',//拍卖师继续开始标的
    target_start:'/user/web/target/start',//拍卖师开始标的
    target_stop:'/user/web/target/stop',//拍卖师开始标的
    auctioneersay:'/user/web/auctioneer/say',//拍卖师发言
    updateTarget:'/user/web/target/update',//拍卖师修改标的信息

    getRecord:'/auction/web/getRecord',//获取当前进行中的标的信息
    // carousel:'/auction/web/carousel/list', //banner列表
    empList:'/auction/web/emp/list', //入驻企业列表
    // 出价记录
    priceList:'/auction/web/list',
    priceAdd:'/user/web/price/add',//新增出价
    auctioneerLogList:'/auction/web/auctioneerLogList',//拍卖师操作记录
    //拍卖会列表
    homemeetList:'/auction/web/meet/list',
    //首页拍卖会统计数据
    homecount:'/auction/web/meet/count',
    // //+id 拍卖会详情
    // auctionmeetDetail:'/auctionmeet/',
    //拍卖公告列表 start: 0 count: 10
    notices:'/auction/web/notice/list',
    // 获取拍卖会信息详细信息
    meet:'/auction/web/meet/',
    //拍卖公告详情
    notice:'/auction/web/notice/',
    // 标的列表
    lots:'/auction/web/target/list',
    //+标的Id 详情
    lotdetail:'/auction/web/target/',
    //新闻 租赁列表  noticeType  2 行业资讯  3 租赁
    noticeList:'/auction/web/noticeList',  
    //新闻 租赁详情
    noticedetail:'/auction/web/new/',
	
	
	material:'/auction/material',//新增物资信息
	materialDetail:'/auction/material/',//获取物资信息详细信息
	materialList:'/auction/material/list',//查询物资信息列表
	//中铁专区列表
	zhongtiezhuanqu:'/auction/web/recyclingInfoList',
	
	//铁建专区列表
	tiejianzhuanqu:'/auction/crcc/list',
}